import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfigService } from '../app-config.service';

@Component({
  templateUrl: `./account.component.html`,
  styleUrls: ['./account.component.scss'],
  standalone: false,
})
export class AccountComponent implements OnInit {
  userUnified$: Observable<string>;

  constructor(private config: AppConfigService) {}

  ngOnInit(): void {
    this.userUnified$ = this.config.config$.pipe(map(({ unifiedUserId }) => unifiedUserId));
  }
}
